function UPDATE_IS_SHOW_LOADING(state, isShowLoading) {
  if (isShowLoading) {
    state.globalLoading.push(true)
  } else {
    state.globalLoading.pop()
  }
}

function UPDATE_GLOBAL_PARAMS(state, payload) {
  state.globalParams = payload
}
/**
 * 更新选中门店信息
 * @param {*} state
 * @param {*} payload 选中的门店
 */
function UPDATE_CURRENT_SHOP(state, payload) {
  state.currentShop = payload
}

/**
 * 更新country code
 * @param {*} state
 * @param {*} payload country code
 */
function UPDATE_CURRENT_COUNTRY(state, payload) {
  state.country = payload
}

/**
 * 更新选中的商户
 * @param {*} state
 * @param {*} payload 选中的商户
 */
function UPDATE_CURRENT_CONTRACTOR(state, payload) {
  state.currentContractor = payload
}

function TOAST(state, payload) {
  if (typeof payload === 'string') {
    payload = {
      msg: payload,
      type: 'warning',
    }
  }
  state.msgBox = { ...payload }
}

function SHOW_MSG(state, payload) {
  if (typeof payload === 'string') {
    payload = {
      msg: payload,
      type: 'warning',
    }
  }
  state.msgBox = { ...payload }
}

/**
 * 全局跳转方法
 * @param {Object} state
 * @param {string | Object} payload
 */
function GOTO(state, payload) {
  state.jumpTo = typeof payload === 'string' ? { path: payload } : { ...payload }
}

function UPDATE_COMMON_CONF(state, value) {
  state.commonConf = Object.assign({}, state.commonConf, value)
}

function UPDATE_ASYNC_API_STATUS(state, payload) {
  const [key, value] = payload
  state.asyncApiStatus = Object.assign({}, state.asyncApiStatus, {
    [key]: value,
  })
}

function UPDATE_PASSPORT_CONTRACTORS(state, contractors) {
  state.passportContractors = contractors
}
const PLATFORM_CHANNEL = 1
const STORE_FRONT_CHANNEL = 2
function UPDATE_CHANNEL_LIST(state, businessChannelList = [PLATFORM_CHANNEL]) {
  state.businessChannelList = businessChannelList
  if (businessChannelList.includes(PLATFORM_CHANNEL)) {
    state.currentBusinessChannel = PLATFORM_CHANNEL
  } else if (businessChannelList.includes(STORE_FRONT_CHANNEL)) {
    state.currentBusinessChannel = STORE_FRONT_CHANNEL
  }
}
function UPDATE_CURRENT_CHANNEL(state, currentChannel = PLATFORM_CHANNEL) {
  state.currentBusinessChannel = currentChannel
}

export default {
  UPDATE_ASYNC_API_STATUS,
  UPDATE_COMMON_CONF,
  UPDATE_IS_SHOW_LOADING,
  UPDATE_GLOBAL_PARAMS,
  UPDATE_CURRENT_SHOP,
  UPDATE_CURRENT_COUNTRY,
  UPDATE_CURRENT_CONTRACTOR,
  UPDATE_PASSPORT_CONTRACTORS,
  TOAST,
  SHOW_MSG,
  GOTO,
  UPDATE_CHANNEL_LIST,
  UPDATE_CURRENT_CHANNEL,
}
